import { SERVICE_NAME } from '../constants';

export const getSegmentsDataKey = (userNumber) =>
  `${SERVICE_NAME}:${userNumber}:SEGMENTS_DATA`;

const DEFAULT_USER_SEGMENTS_DEFAULT = {
  segments: [],
  timestamp: 0,
};

/**
 * @param {string} key
 * @returns {{segments?:Array<number|string>, timestamp?:number}}
 */
export const getUserSegmentsData = (key) => {
  try {
    const localStorageData = localStorage.getItem(key);
    return localStorageData
      ? { ...DEFAULT_USER_SEGMENTS_DEFAULT, ...JSON.parse(localStorageData) }
      : DEFAULT_USER_SEGMENTS_DEFAULT;
  } catch (e) {
    return DEFAULT_USER_SEGMENTS_DEFAULT;
  }
};
